import { render, staticRenderFns } from "./PAExceptional.vue?vue&type=template&id=24247676&"
import script from "./PAExceptional.vue?vue&type=script&lang=js&"
export * from "./PAExceptional.vue?vue&type=script&lang=js&"
import style0 from "./PAExceptional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAExceptional.vue"
export default component.exports